import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CSVLink } from 'react-csv';
import Moment from 'react-moment';
import 'moment-timezone';
import { format } from 'date-fns';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_AFFILIATE_CREW_PROFILE,PAGENUMROWS_AFFILIATE,PAGING_END_INDEX,LOGIN_AFFILIATE_GROUP} from '../../configs/staticConfigs';
import{ MSG_CREW_DELETED,MSG_CREW_DELETE, MSG_NOT_FOUND,MSG_NOT_LOGGED_IN, MSG_FILE_FORMAT_ERROR, MSG_CREW_EMAIL_ALREADY_EXIST, MSG_FILE_NAME_ERROR, MSG_CREW_IMPORT_SUCCESS,MSG_SERVER_DATA_FETCH_ERROR, MSG_SHIFT_TOTAL_MSG, MSG_CSV_DOWNLOAD_ERROR, MSG_FILE_NAME_STRAT_WITH} from '../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_CREW,LBL_CREW_LIST, LBL_SLNUM, LBL_NAME, LBL_MOBILE_NUMBER, LBL_CHIEF, LBL_LAST_LOGIN, LBL_EMAIL, LBL_SKILLS, LBL_DATE_OF_JOIN, LBL_AVAILABILITY, LBL_APPROVED, LBL_EDIT, LBL_ADD_NEW, LBL_FILTER, LBL_CSV_EXPORT, LBL_CSV_IMPORT, LBL_ARE_YOU_SURE_DELETE_CREW, LBL_CLEAR_FILTERS,LBL_CONFIRM_DELETE } from '../../configs/labelConfigs';
import { IMPORT_CREW_CSV_FILE_NAME } from '../../configs/staticConfigs';

import {crewListAction, crewActiveDeactiveAction, crewImportAction,crewListDownloadAction} from '../../actions/crewActions'; // crewAllListAction
import {clearAction} from '../../actions/commonActions';
import * as types from '../../actions';


import {checkPermissions} from '../../utils/permissions';

import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import FilterCrew from './filterCrew';
import {csvFileCheck} from '../../utils/validation';

class CrewListComponent extends Component {

   constructor(props){
      super(props)

      this.state = {
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         activeRowId:0,    
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'-id',
         sortOrder:'',  
         isFilterOn: false,
         crewId:'',   
         crewName:'', 
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         searchString:'',
         crewData:{},
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},
         clientId: 0, 
         isClientPage:false,
         crews: [],
         downloadCrews: [],
      }

      this.onShowActionButtons = this.onShowActionButtons.bind(this);
      this.onHideActionButtons = this.onHideActionButtons.bind(this);
      this.modalDelete = React.createRef(); 
      this.csvUploader = React.createRef(); 
   }

   onCSVDownload = () => {
      this.props.crewListDownloadAction({pageSize:0,page:0,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,csvDownload:1}); 
  }

   onResetFiltersButton = () => {   
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
         this.setState({resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-id', applyFilter:0, filtersData:{}}, () => { 
            this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString)});
            if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
            }
            else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
            }
         });
      }
      else {
          this.setState({resetFilterClicked,applyFilter:0}); 
      }
   }

   onApplyFilterButton = () => {
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let applyFilter = 0; 
      if(filtersData.filtersSelected > 0) applyFilter = 1; 
      this.setState({activePage:1, sortOrder:'', sortField:'-id', applyFilter:applyFilter, filtersData:filtersData}, () => { 
         this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:applyFilter,filtersData:filtersData});
      });
   }

   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');
   }

   onShowActionButtons = (event, rowId) =>{

      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
      }        
      
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }   

   deleteBtnClick = (rowId,name) =>{
      this.setState({
         crewId:rowId,
         crewName:name          
      }); 
      this.modalDelete.current.handleOpenModal();
   }

   onDeleteAction = () =>{
      let crewId = this.state.crewId;
      let data = {
         is_active:false,
         profileId:crewId
      }
      this.props.crewActiveDeactiveAction(data);
      this.modalDelete.current.handleModelClose();                    
   }    
   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      this.props.crewListAction({pageSize:this.state.perPageCount,page:previousPage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => {
    
      this.props.crewListAction({pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
 
      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      this.props.crewListAction({pageSize:this.state.perPageCount,page:nextPage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:sOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
          this.setState({ sortOrder:sOrder });            
      }else{
          this.setState({ sortField:sortKey });
          this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+sortKey,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }        
   }

   onModalFormReset = () =>{       
      this.setState({
         crewId:'',
      }); 
   }


   goToCrewProfile(e,id,newTab) {
      let profileId = '';
      if(id){
         profileId = id; 
         if(newTab) window.open(ROUTE_AFFILIATE_CREW_PROFILE+'/'+profileId, "_blank"); 
         else this.props.history.push(ROUTE_AFFILIATE_CREW_PROFILE+'/'+profileId);
      }
      else {
         this.props.history.push(ROUTE_AFFILIATE_CREW_PROFILE);
      }
   }  

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   applySearch = (e)=>{
      this.setState({searchString:e.target.value})
      if(e.target.value.trim().length >=3) {
         this.props.crewListAction({pageSize:this.state.perPageCount,page:1,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }
      else if(e.target.value.trim().length===0) {
         this.props.crewListAction({pageSize:this.state.perPageCount,page:1,column:this.state.sortOrder+this.state.sortField,search:e.target.value,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }
   }

   setToasterState(isEnabled,message,isSucces,ms=3000){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      setTimeout(()=> {
          this.onCloseToast();
      }, ms);
   }

   setStateUpdate(numRows,totalPage,activity,errorData,crewId,status){
      let arrTemp = [];
      arrTemp = activity ? activity.split('~~') : []; 
      if(arrTemp[0] && arrTemp[0]===types.CREW_LIST_SUCCESS) {
         // if(status===200)  - THIS CHECKING IS DONE IN THE REDUCER 
         this.setState({crews:this.props.crews}); 
      }
      else if(arrTemp[0] && arrTemp[0]===types.CREW_LIST_ERROR) {
         this.setState({crews:[]}); 
         this.setToasterState(true,MSG_SERVER_DATA_FETCH_ERROR,false,4000);
      }
      

      if(activity===types.CREW_ACTIVE_DEACTIVE_SUCCESS){
         if (numRows===1 && totalPage > 1){
            let page = this.state.activePage-1;
            this.props.crewListAction({pageSize:this.state.perPageCount,page:page,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
        }else{
            this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
        }    
        this.setToasterState(true,MSG_CREW_DELETE,true);   
      }else if(activity===types.CREW_ACTIVE_DEACTIVE_ERROR){
         this.setToasterState(true,JSON.stringify(errorData),false); 
      }else if(activity===types.CREW_IMPORT_SUCCESS){
          if (numRows===1 && totalPage > 1){
              let page = this.state.activePage-1;
              this.props.crewListAction({pageSize:this.state.perPageCount,page:page,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
          }else{
              this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
          }
          
          if(crewId.existing_emails !==undefined && crewId.existing_emails.length>0){
            let message = "";
            message += MSG_CREW_EMAIL_ALREADY_EXIST + " \n"
            message += "\n"+crewId.existing_emails.join(',\n\t')
            this.setState({toastFlag:true,toastMessage:message,toastSuccess:false});
          }else{
            if(crewId.crew_profile_id != undefined && crewId.crew_profile_id.length > 0){
              this.setToasterState(true,MSG_SHIFT_TOTAL_MSG+' '+crewId.crew_profile_id.length.toString()+' '+MSG_CREW_IMPORT_SUCCESS,true,5000);

            }else{
              this.setToasterState(true,MSG_CREW_IMPORT_SUCCESS,true);
            }
            
          }
          document.getElementsByName("csvFile")[0].value = "";


      }else if(activity===types.CREW_IMPORT_ERROR){
        let message = "";
         if("email" in errorData){
            message = errorData.email[0]
            this.setToasterState(true,message,false); 
         }else if("message" in errorData){
            this.setToasterState(true,errorData.message,false); 
         }else{
            this.setToasterState(true,JSON.stringify(errorData),false); 
         }
         document.getElementsByName("csvFile")[0].value = "";
         
      }  
   } 

   componentDidUpdate(prevProps) {
      const {isFilterOn,numRows,totalPage,activity,errorData,crewId,status,downloadCrews,downloadStatus, downloadActivity} = this.props;    

      let arrDn = [];  
      if (downloadActivity && (downloadStatus !== prevProps.downloadStatus || downloadActivity!==prevProps.downloadActivity)) {
         arrDn = downloadActivity.split('~~'); 
         if(arrDn[0]===types.CREW_LIST_DOWNLOAD_SUCCESS) { 
               this.setState({downloadCrews:this.formatCrewArray(downloadCrews)}, () => {
                  console.log(this.state.downloadCrews); 
                  setTimeout(()=> {
                     let csvDownload = document.getElementById('CSVLinkDownload'); 
                     csvDownload.click(); 
                  }, 500);
               });
         }
         else if(arrDn[0]===types.CREW_LIST_DOWNLOAD_ERROR) {
               this.setToasterState(true,MSG_CSV_DOWNLOAD_ERROR,false); 
         }
      }

      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      }else if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData,crewId,status);
         this.props.clearAction();
      }

      
      
   }

   componentDidMount() {
        const { location } = this.props;

      //   if(location.state!==undefined && location.state.hasOwnProperty('crewName')){ // to show success message after deactivate
      //       this.setToasterState(true,LBL_CREW+" "+location.state.crewName+" "+MSG_CREW_DELETED,true); 
      //       window.history.pushState(null, '');
      //    }
         if(location.state!==undefined && location.state.hasOwnProperty('toastMessageStr')){ // to show success message after deactivate
            this.setToasterState(true,location.state.toastMessageStr,true); 
            window.history.pushState(null, '');
         }
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        document.title = LBL_APP_NAME+" - "+LBL_CREW_LIST;
        this.props.crewListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
        // this.props.crewAllListAction();
   }

   formatCrewArray(array){
      let exportCrew = [];
      if(array.length>0){
         array.map(item => {
            let  crewObj = {};
            crewObj['name'] = item.user_detail.first_name+' '+item.user_detail.last_name;
            crewObj['email'] = item.user_detail.email;
            crewObj['phone'] = item.phone_number;
            crewObj['other_phone'] = item.altername_number;
            crewObj['is_chief'] = item.chief_eligibility===true?'Yes':'No';
            crewObj['created_date'] = format(new Date(item.created_on), 'dd/MM/yyyy hh:mm');
            crewObj['last_login'] = item.user_detail.last_login===null?MSG_NOT_LOGGED_IN:format(new Date(item.user_detail.last_login), 'dd/MM/yyyy hh:mm');
            crewObj['status'] = item.availability_status===true?'Active':'Inactive';
            crewObj['dob'] = item.date_of_birth;
            crewObj['nationality'] = item.country_name;
            crewObj['street1'] = item.street1;
            crewObj['street2'] = item.street2;
            crewObj['city'] = item.city;
            crewObj['state'] = item.state;
            crewObj['country'] = item.country;
            crewObj['postcode'] = item.postcode;
            
            exportCrew.push(crewObj);
            return exportCrew;
         }); 
      }
      return exportCrew;

   }
   onHandleCsvImport = (e) =>{
         e.preventDefault();
         this.csvUploader.current.click();
    }
  
    onHandleChange = (e) =>{
        const {name}  = e.target;    
        const value =
        e.target.type === "file" ? e.target.files[0] : e.target.value;

        let crewData      = this.state.crewData;
    
        crewData[name] = value;   

        if(e.target.type=== "file"){
            //  if(!e.target.files[0].name.startsWith(IMPORT_CREW_CSV_FILE_NAME.split(".csv")[0])){
            //   this.setToasterState(true,`${MSG_FILE_NAME_ERROR} ${MSG_FILE_NAME_STRAT_WITH} "${IMPORT_CREW_CSV_FILE_NAME.split(".csv")[0]}"`,false);
            //               }else 
            if(csvFileCheck(e.target.files[0].name)){
                const data = new FormData(); 
                data.append('file', value);            
                data.append('group', 5);            
                this.props.crewImportAction(data);
            }else{
                this.setToasterState(true,MSG_FILE_FORMAT_ERROR,false);
            }         
            
        }
   }  
   
   render(){

      const {
         crews, activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess           
     } = this.state  

      const {  crewAll,totalPage,status } = this.props; 

      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = '';
      let supervisor_name = ''; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group;
         supervisor_name = userGroupData.supervisor_name
      }

      if(!supervisor_name){
        supervisor_name = LBL_CHIEF;
      }
      
      if(status===401 || status===403){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
         }else{
            return <Redirect to={ROUTE_REFRESH} />;
         }
      }

      let headers = [
         { label: "Name", key: "name" },
         { label: "Email", key: "email" },
         { label: "Phone", key: "phone" },
         { label: "Alternate number", key: "other_phone" },
         { label: "Eligible for chief role", key: "is_chief" },
         { label: "Created Date", key: "created_date" },
         { label: "Last Login", key: "last_login" },
         { label: "Availability Status", key: "status" },
         { label: "Date of birth", key: "dob" },
         { label: "Nationality", key: "nationality" },
         { label: "Street1", key: "street1" },
         { label: "Street2", key: "street2" },
         { label: "City", key: "city" },
         { label: "State", key: "state" },
         { label: "Country", key: "country" },
         { label: "Postcode", key: "postcode" }

      ];

      // let exportCrew = [];
      // if(activePage===1){
      //    // logic to get the whole crew 
      //    exportCrew = this.formatCrewArray(crewAll);
      // }else{
      //    exportCrew = this.formatCrewArray(crews);
      // }

      let isAddCrew = checkPermissions("crew","modify");
     

      return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

               <div className="box">
                  <div className="box-head">
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={LBL_NAME+'/'+LBL_EMAIL+'/'+LBL_MOBILE_NUMBER} id="my-search-input" onChange={this.applySearch} /></label>
                     </div>
                     <div className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'} >
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER} 
                          </Tooltip>}
                        >
                           <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                        </OverlayTrigger>
                     </div>
                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>} 
                     {isAddCrew && 
                      <div className="to-right padding-right-15">
                          <Link to="#" className="btn btn-primary" onClick={e => this.goToCrewProfile(e)} >{LBL_ADD_NEW} </Link>
                      </div>
                     }
                     <div className="to-right filter-btn-wrapper">                       
                        {this.props.hasOwnProperty("count") && this.props.count > 0 && <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="download-tooltip" style={{ opacity: 0.4, }}>
                            {LBL_CSV_EXPORT}
                            </Tooltip>} 
                             ><Link to="#" onClick={e => this.onCSVDownload()} className="btn btn-outline-primary filter-btn" ><i className="las la-file-download"></i></Link>
                        </OverlayTrigger>}
                        {this.state.downloadCrews.length > 0 && <CSVLink id="CSVLinkDownload" className="hidden" data={this.state.downloadCrews} headers={headers} filename= {"crew-list.csv"}></CSVLink>}
                        {/* <CSVLink className="btn btn-outline-primary filter-btn" data={exportCrew} headers={headers} filename= {"crew-list.csv"} ><i className="las la-file-csv"></i></CSVLink> */}
                     </div>
                     {isAddCrew &&
                     <div className="to-right filter-btn-wrapper"> 
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="download-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_CSV_IMPORT}
                            </Tooltip>}
                             >
                                 <Link to="#" onClick={(e) => this.onHandleCsvImport(e)} className="btn btn-outline-primary filter-btn"><i className="las la-file-import"></i> </Link> 
                           </OverlayTrigger>       
                        <input name="csvFile" type="file" accept=".csv" id="file" ref={this.csvUploader} onChange={this.onHandleChange} style={{display: "none"}}/>                    
                     </div>
                   }
                  </div>
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th>{LBL_SLNUM}</th>                                
                                 <th onClick={(e) => this.onSort(e,'user__first_name')}className="name sorting_asc" >{LBL_NAME}</th>
                                 <th onClick={(e) => this.onSort(e,'user__email')} className="sorting_asc">{LBL_EMAIL}</th>
                                 <th onClick={(e) => this.onSort(e,'phone_number')} className="mobile-number sorting_asc mobile-number-td">{LBL_MOBILE_NUMBER}</th>
                                 <th className="crew-list-skills-td">{LBL_SKILLS}</th> 
                                 <th className="eligible-person text-center">{supervisor_name}?</th>
                                 <th onClick={(e) => this.onSort(e,'user__last_login')} className="last-login-date sorting_asc">{LBL_LAST_LOGIN}</th>
                                 <th onClick={(e) => this.onSort(e,'created_on')} className="date-join sorting_asc">{LBL_DATE_OF_JOIN} </th>
                                 <th className="text-center">{LBL_AVAILABILITY}</th>
                                 <th className="text-center">{LBL_APPROVED}</th>
                                 <th className="action">&nbsp;</th>
                              </tr>
                           </thead>
                           <tbody>
                           {(this.props.count===0)  && 
                                    <tr>
                                        <td colSpan="10" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                            }
                           { crews.map((item, index)  => {
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1;
                                    let skills = item.skills;
                                    return (
                                        <tr key={index}>
                                             <td>{indeNum}</td>
                                             {isAddCrew && 
                                             <td><Link to="#" onClick={(e) => this.goToCrewProfile(e,item.id)} onContextMenu={(e) => this.goToCrewProfile(e,item.id,'newTab')} >{item.user_detail.first_name+' '+item.user_detail.last_name}</Link><p className="mb-0"><small>
                                                {item.pay_level.level_name===null?'':item.pay_level.level_name}</small></p></td>
                                              }
                                              {!isAddCrew &&
                                                <td><p className="mb-0">
                                                {item.user_detail.first_name+' '+item.user_detail.last_name}</p>
                                                <p className="mb-0"><small>
                                                {item.pay_level.level_name===null?'':item.pay_level.level_name}</small></p></td>
                                              }

                                             <td>{item.user_detail.email}<small className="block text-red">{item.email_verified===false?'Not Verified':''}</small></td>
                                             <td>{item.phone_number}</td>
                                             <td>
                                                {
                                                   skills.map((sk, i)  => {
                                                      return(
                                                         <span key={i}>{sk.skill_name}{i < skills.length - 1 ? ", " : ""}</span>
                                                      )
                                                   })
                                                }
                                             </td>
                                             <td className="text-center">{item.chief_eligibility===true?'Yes':'No'}</td>
                                             <td>{( item.user_detail.last_login!==null&&
                                                <Moment format="DD/MM/YYYY HH:mm">
                                                   {item.user_detail.last_login}
                                                </Moment>
                                             )}
                                             {( item.user_detail.last_login===null&&
                                                <React.Fragment>
                                                   {MSG_NOT_LOGGED_IN}
                                                </React.Fragment>
                                             )}
                                             </td> 
                                             <td><Moment format="DD/MM/YYYY HH:mm">
                                                   {item.created_on}
                                                </Moment>
                                             </td>
                                             <td className="text-center">{item.availability_status===true?'Active':'Inactive'}</td>
                                             <td className="text-center">{item.is_approved===true?'Yes':'No'}</td>
                                             <td>
                                             {isAddCrew && 
                                             <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                    onBlur={(e) => this.onHideActionButtons(e, item.id)}
                                                    >
                                                    <img id="test" src={require('../../'+URL_IMG+'action.png')} alt="Action" />
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                      {/* <Link className="dropdown-item" to="#">Login As</Link> */}
                                                      <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.goToCrewProfile(e,item.id)}>{LBL_EDIT}</Link>
                                                      {/* <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.user_detail.first_name+' '+item.user_detail.last_name)}>Delete</Link> */}
                                                </div>
                                            </div>
                                            }
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                      
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>
               <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
               {LBL_ARE_YOU_SURE_DELETE_CREW+" '"+this.state.crewName+"'?"}
               </ModalWindow>
            </div>
            <Filter isDetail={true} onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} >
               <FilterCrew filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} isClientPage={this.state.isClientPage} clientId={this.state.clientId}  onShowFilterBy={this.onShowFilterBy} />
               <div>&nbsp;</div>
            </Filter>
         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      

      return {
         downloadCrews: state.crews.downloadItems,
         downloadStatus: state.crews.downloadStatus,
         downloadActivity: state.crews.downloadActivity,
         crews : state.crews.items,
         crewAll:state.crews.crewList,
         totalPage:state.crews.totalPage,
         status:state.crews.status,
         activity:state.crews.activity,
         numRows:state.crews.numRows,
         count:state.crews.count,
         errorData:state.crews.errorData,
         crewId:state.crews.crewId,
         isFilterOn: state.commons.isFilterOn,
         //crewId: state.crews.crewId    
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
         crewListAction:crewListAction,
         crewActiveDeactiveAction:id=>crewActiveDeactiveAction(id),
         crewImportAction:data=>crewImportAction(data),
         clearAction:clearAction,
         crewListDownloadAction:crewListDownloadAction,
    },dispatch); //  crewAllListAction:crewAllListAction,
}
export default connect(mapStateToProps,mapDispatchToProps)(CrewListComponent);